/**
 * Delly Hero carousel: shows one slide at a time, auto-rotating every 6.5s
 * (matching the source prototype), with click-to-select dots. Autoplay is
 * skipped for prefers-reduced-motion and pauses on hover/focus.
 */
(function () {
  const ROTATE_MS = 6500;

  document.querySelectorAll('[data-delly-hero]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-delly-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-delly-hero-dot]'));
    const previousButton = root.querySelector('[data-delly-hero-previous]');
    const nextButton = root.querySelector('[data-delly-hero-next]');
    if (slides.length === 0) return;

    let index = 0;
    let timer = null;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    }

    function start() {
      if (prefersReducedMotion || slides.length < 2) return;
      stop();
      timer = window.setInterval(() => show(index + 1), ROTATE_MS);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        show(i);
        start();
      });
    });

    previousButton?.addEventListener('click', () => {
      show(index - 1);
      start();
    });

    nextButton?.addEventListener('click', () => {
      show(index + 1);
      start();
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    show(0);
    start();
  });
})();
